import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=558afa6b&scoped=true"
var script = {}
import style0 from "./Page4.vue?vue&type=style&index=0&id=558afa6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558afa6b",
  null
  
)

export default component.exports